import { CENTRAL_PERIPHERAL_ECCENTRICITIES, peripheralMarkerRadiusPixels } from './modules/central-peripheral';
import {
  MOVING_TARGET_GUIDE_HALF_PATH_DEGREES,
  MOVING_TARGET_HALF_HEIGHT_DEGREES,
} from './modules/moving-target';
import {
  PLAYER_TRACK_X_LIMIT_DEGREES,
  PLAYER_TRACK_Y_LIMIT_DEGREES,
  playerTrackMarkerRadiusPixels,
} from './modules/player-track';

export interface TrainingViewportRequirement {
  halfWidthPixels: number;
  halfHeightPixels: number;
}

/**
 * Calculates the actual protocol-2 stimulus envelope after physical screen
 * calibration. This replaces the former blanket 16° gate.
 */
export function trainingViewportRequirement(pixelsPerDegree: number): TrainingViewportRequirement {
  const peripheralRadius = peripheralMarkerRadiusPixels(pixelsPerDegree);
  const trackRadius = playerTrackMarkerRadiusPixels(pixelsPerDegree);
  const maximumPeripheralEccentricity = Math.max(...CENTRAL_PERIPHERAL_ECCENTRICITIES);
  return {
    halfWidthPixels: Math.max(
      maximumPeripheralEccentricity * pixelsPerDegree + peripheralRadius,
      MOVING_TARGET_GUIDE_HALF_PATH_DEGREES * pixelsPerDegree,
      PLAYER_TRACK_X_LIMIT_DEGREES * pixelsPerDegree + trackRadius * 1.5,
    ),
    halfHeightPixels: Math.max(
      maximumPeripheralEccentricity * pixelsPerDegree + peripheralRadius,
      MOVING_TARGET_HALF_HEIGHT_DEGREES * pixelsPerDegree,
      PLAYER_TRACK_Y_LIMIT_DEGREES * pixelsPerDegree + trackRadius * 1.5,
    ),
  };
}

export function trainingStimuliFitViewport(
  width: number,
  height: number,
  pixelsPerDegree: number,
): boolean {
  if (width <= 0 || height <= 0 || pixelsPerDegree <= 0 || !Number.isFinite(pixelsPerDegree)) return false;
  const requirement = trainingViewportRequirement(pixelsPerDegree);
  return requirement.halfWidthPixels <= width / 2 && requirement.halfHeightPixels <= height / 2;
}
